import { Switch } from '@progress/kendo-react-inputs';
import { SettingBooleanKeys } from '../../../../../../services/settings-service';
import { useSettingSwitchValue } from '../../../../home/hooks/settings';
import { useSearchContext } from '../../../context/SettingsSearchContext';
import MarkerText from '../../../../../components/inputs/MarkerText';

export function SettingsBoolElement(props: { name: string; hint?: string; settingKey: SettingBooleanKeys }) {
    const setting = useSettingSwitchValue(props.settingKey);
    const context = useSearchContext();
    return (
        <div className="d-flex justify-content-between px-3 align-items-center">
            <div>
                <MarkerText highlight={context.term}>{props.name}</MarkerText>
                <div>
                    <MarkerText highlight={context.term} className="secondary-text">
                        {props.hint}
                    </MarkerText>
                </div>
            </div>
            <Switch {...setting} />
        </div>
    );
}
